import { useEffect, useState } from "react";
import { changePaperAccount } from "../../services/APIService";


interface Props {
  tag: string;
  agbStatus: number;
  dsgvoStatus: number;
  useCondStatus: number;
}

export const useCondPopupViewModel = ({
  tag,
  agbStatus,
  dsgvoStatus,
  useCondStatus,
}: Props) => {

  const [isVisible, setIsVisible] = useState(false);
  const [agbChecked, setAgbChecked] = useState(false);
  const [dsgvoChecked, setDsgvoChecked] = useState(false);
  const [useCondChecked, setUseCondChecked] = useState(false);

  useEffect(() => {
    if (agbStatus !== 1 || dsgvoStatus !== 1 || useCondStatus !== 1) {
      setIsVisible(true);
    }
  }, [agbStatus, dsgvoStatus, useCondStatus]);

  const confirm = async () => {
    const canConfirm =
      (agbStatus === 1 || agbChecked) &&
      (dsgvoStatus === 1 || dsgvoChecked) &&
      (useCondStatus === 1 || useCondChecked);

    if (!canConfirm) {
      alert("Bitte akzeptieren Sie alle Bedingungen");
      return;
    }

    try {
      await changePaperAccount(tag);
      setIsVisible(false);
    } catch (error) {
      console.error("Fehler beim Bestätigen:", error);
      alert("Fehler beim Speichern");
    }
  };

  return {
    isVisible,
    agbStatus,
    dsgvoStatus,
    useCondStatus,
    agbChecked,
    dsgvoChecked,
    useCondChecked,
    setAgbChecked,
    setDsgvoChecked,
    setUseCondChecked,
    confirm
  };
};